import { app } from '../../../../app';

app.factory('FidoRegistrationDataService', FidoRegistrationDataService);

/** @ngInject */
function FidoRegistrationDataService($resource) {
	var url ='app/rest/userFidoRegistration';
    return $resource(url, {}, {
		'getData' : {
            method : 'GET',
            url : url+'?vkey=:vKey',
            params : {
                vKey: '@vKey'
            }
        },
        'startRegistration' : {
            method : 'POST',
            url : url+'/:hardTokenId/start?vkey=:vKey',
            params : {
				hardTokenId: '@hardTokenId',
                vKey: '@vKey'
            }
        },
        'finishRegistration' : {
            method : 'POST',
            url : url+'/:hardTokenId/finish',
            params : {
				hardTokenId: '@hardTokenId'
            }
        }
	
	});
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/fido-registration/fido-registration.service.js